import { render, staticRenderFns } from "./appointment.vue?vue&type=template&id=8e0ccd22&scoped=true"
import script from "./appointment.vue?vue&type=script&lang=js"
export * from "./appointment.vue?vue&type=script&lang=js"
import style0 from "./appointment.vue?vue&type=style&index=0&id=8e0ccd22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e0ccd22",
  null
  
)

export default component.exports